import * as React from "react";
import { FaShoppingBag, FaMotorcycle, FaUtensils, FaCalendarAlt } from "react-icons/fa";

export const OrderIcon = (props: { service: RestaurantServiceTypes }) => {
  switch (props.service) {
    case "pickup":
      return <FaShoppingBag/>;
    case "delivery":
      return <FaMotorcycle/>;
    case "dine_in":
      return <FaUtensils/>;
    case "table_booking":
      return <FaCalendarAlt/>;
    default:
      return <FaShoppingBag/>;
  }
};
